// CSS Modules - component class name: NewsletterForm__

<template>
  <form :class="$style.container">
    <p :class="$style.text">{{ config.text }}</p>
    <div :class="[$style.checkboxes, 'columns is-mobile is-multiline']">
      <div
        v-for="(checkbox, index) in config.newsletters"
        :key="`checkbox-${index}`"
        class="column is-half"
      >
        <input
          :id="`checkbox-${index}`"
          type="checkbox"
          :name="`checkbox-${index}`"
          :value="checkbox.newsletterId"
          v-model="newsletterIds"
        />
        <label :for="`checkbox-${index}`">{{ checkbox.label }}</label>
      </div>
    </div>
    <div :class="$style.serverError" v-if="checkboxError">
      {{ config.checkboxErrorMessage }}
    </div>
    <div class="columns">
      <div class="column is-half-tablet">
        <FormInput
          v-model.trim="$v.formData.email.$model"
          :label="config.labels.email.label"
          :boldLabel="true"
          :errorMessage="config.labels.email.errorMessage"
          :error="$v.formData.email.$error && $v.$dirty && isSubmitted"
          :originalValue="
            previousData.email && previousData.email !== ''
              ? previousData.email
              : null
          "
          :formSubmitSwitch="formSubmitSwitch"
        />
      </div>
    </div>
    <p :class="$style.title">{{ config.optionalSectionTitle }}</p>
    <p :class="$style.text">{{ config.optionalSectionText }}</p>
    <div class="columns">
      <div class="column">
        <FormSelect
          v-model="formData.anrede"
          :label="config.labels.title.label"
          :optionalLabel="config.labels.title.optionLabel"
          :error="false"
          :options="config.titleSelectOptions"
          :initialOption="config.titleInitialSelectOption"
        />
      </div>
      <div class="column">
        <FormSelect
          v-model="formData.land"
          :label="config.labels.country.label"
          :optionalLabel="config.labels.country.optionLabel"
          :error="false"
          :options="config.selectOptions"
          :initialOption="config.initialSelectOption"
        />
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <FormInput
          v-model="formData.vorname"
          :label="config.labels.firstName.label"
          :boldLabel="true"
          :optionalLabel="config.labels.firstName.optionLabel"
          :error="false"
          :originalValue="
            previousData.firstName && previousData.firstName !== ''
              ? previousData.firstName
              : null
          "
          :formSubmitSwitch="formSubmitSwitch"
        />
      </div>
      <div class="column">
        <FormInput
          v-model="formData.name"
          :label="config.labels.lastName.label"
          :boldLabel="true"
          :optionalLabel="config.labels.lastName.optionLabel"
          :error="false"
          :originalValue="
            previousData.lastName && previousData.lastName !== ''
              ? previousData.lastName
              : null
          "
          :formSubmitSwitch="formSubmitSwitch"
        />
      </div>
    </div>
    <div :class="['columns', $style.dataSecurityColumn]">
      <div :class="['column', $style.dataSecurityChecked]">
        <input
          :id="`checkbox-dataSecurity`"
          type="checkbox"
          :name="`checkbox-dataSecurity`"
          v-model.trim="$v.formData.dataSecurity.$model"
          :class="
            $v.formData.dataSecurity.$error &&
              $v.$dirty &&
              isSubmitted &&
              'error'
          "
        />
        <label
          :for="`checkbox-dataSecurity`"
          v-html="config.dataSecurityText"
        ></label>
        <div
          :class="$style.dataSecurityError"
          v-if="$v.formData.dataSecurity.$error && $v.$dirty && isSubmitted"
          v-html="config.dataSecurityErrorMessage"
        ></div>
      </div>
    </div>
    <div :class="$style.serverError" v-if="serverError">
      {{ config.serverErrorMessage }}
    </div>
    <div :class="$style.serverSuccess" v-if="serverSuccess">
      <p>{{ config.subscribeSuccess }}</p>
      <p>{{ config.confirmationHint }}</p>
      <p>{{ config.spamFilterHint }}</p>
    </div>
    <div class="columns">
      <div class="column has-text-right-tablet">
        <Button
          colour="blue"
          :text="config.buttonText"
          type="submit"
          :isForm="true"
          @close="handleSubmit"
        >
        </Button>
      </div>
    </div>
    <ReCaptcha :executeSwitch="executeSwitch" :submit="submit" />
  </form>
</template>

<script>
import { email, required } from "vuelidate/lib/validators";
import ReCaptcha from "../ReCaptcha/ReCaptcha";
import FormInput from "../FormInput/FormInput";
import FormSelect from "../FormSelect/FormSelect";
import Button from "../Button/Button";
import axios from "axios";

function shouldBeTrue(val) {
  return val === true;
}

export default {
  name: "NewsletterSubscribe",
  components: {
    ReCaptcha,
    Button,
    FormInput,
    FormSelect
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      formData: {
        newsletter: "",
        vorname: "",
        name: "",
        anrede: "",
        land: "",
        email: "",
        domain: "",
        pageUrl: "",
        token: "",
        dataSecurity: false
      },
      newsletterIds: [],
      previousData: {},
      isSubmitted: false,
      formSubmitSwitch: false,
      executeSwitch: false,
      showThankyou: false,
      serverError: false,
      serverSuccess: false,
      checkboxError: false
    };
  },
  validations: {
    formData: {
      email: {
        required,
        email
      },
      dataSecurity: {
        shouldBeTrue
      }
    }
  },
  mounted() {
    if (this.config.initialSelectOption) {
      this.formData.land = this.config.initialSelectOption;
    }
    if (this.config.titleInitialSelectOption) {
      this.formData.anrede = this.config.titleInitialSelectOption;
    }
    const queries = window.location.search.substring(1).split("&");
    if (queries) {
      for (const query of queries) {
        if (query.includes("email")) {
          this.formData.email = query.split("=")[1];
        }
      }
    }
  },
  methods: {
    handleSubmit() {
      this.serverError = false;
      this.serverSuccess = false;
      this.checkboxError = false;
      this.$v.$touch();
      this.isSubmitted = true;
      this.formSubmitSwitch = !this.formSubmitSwitch;
      if (!this.$v.$invalid) {
        if (this.newsletterIds.length !== 0) {
          this.executeSwitch = !this.executeSwitch;
        } else {
          this.checkboxError = true;
        }
      } else {
        this.previousData = JSON.parse(JSON.stringify(this.formData));
      }
    },
    submit(token) {
      this.formData.token = token;
      this.formData.domain = window.location.origin;
      this.formData.pageUrl = window.location.pathname;
      let combinedRequests = [];
      for (const id of this.newsletterIds) {
        this.formData.newsletter = id;
        combinedRequests.push(
          axios({
            url: window.newsletterSubscribeUrl,
            method: "post",
            data: { ...this.formData },
            responseType: "json"
          })
        );
      }
      axios
        .all(combinedRequests)
        .then(
          axios.spread((...responses) => {
            if (responses.every(response => response.status === 200)) {
              this.serverSuccess = true;
            } else {
              this.serverSuccess = false;
              this.serverError = true;
            }
          })
        )
        .catch(errors => {
          this.serverSuccess = false;
          this.serverError = true;
          console.error(errors);
        });
    }
  }
};
</script>

<style module lang="scss">
@import "./NewsletterForm.scss";
</style>
